import { render, staticRenderFns } from "./DetailProyek.vue?vue&type=template&id=cb8e815e&scoped=true"
import script from "./DetailProyek.vue?vue&type=script&lang=js"
export * from "./DetailProyek.vue?vue&type=script&lang=js"
import style0 from "./DetailProyek.vue?vue&type=style&index=0&id=cb8e815e&prod&scoped=true&lang=css"
import style1 from "./DetailProyek.vue?vue&type=style&index=1&id=cb8e815e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8e815e",
  null
  
)

export default component.exports